import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Ref, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getThousandMoney } from '@/utils/index'
import { confirmServiceChargeOrderApplyInvoice } from '@/apis/insurance'
import { ServiceChargeListDataItemType, DevicePayInfoType } from '@/types/insurance'
import ApplyInvoiceWrap from '../components/apply-invoice-wrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'apply-invoice',
  setup(__props) {

const detail: Ref<DevicePayInfoType | null> = ref(null)
const $router = useRouter()
const costInfoStyle = {
  fontWeight: 'bold',
}
const guid = ref('')

async function initStorageData(data: ServiceChargeListDataItemType) {
  guid.value = data.guid
  detail.value = {
    deviceCommonInfo: {
      img: data.logo,
      name: `服务费用单据: ${data.order_no}`,
      sequence: data.serial_number,
    },
    serviceInfoList: [
      {
        label: '设备型号',
        value: data.eq_model,
      },
      {
        label: '报修时间',
        value: data.created_at,
      },
      {
        label: '费用明细',
        value: '查看详情',
        routeInfo: {
          name: `malfunction-repair-service-bill-detail`,
          query: {
            guid: data.guid,
          },
        },
      },
    ],
    costInfo: [],
    buyInfo: {
      title: '服务费用合计',
      price: getThousandMoney(Number(data.pay_amount)),
    },
  }
}
function applySuccess() {
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ApplyInvoiceWrap, {
    detail: detail.value,
    onStorageInit: initStorageData,
    onApplySuccess: applySuccess,
    guid: guid.value,
    confirmHandle: _unref(confirmServiceChargeOrderApplyInvoice)
  }, null, 8, ["detail", "guid", "confirmHandle"]))
}
}

})